module.exports = __webpack_public_path__ + "img/twitter.adc022d9.png";